<div class="col-xs-12 col-md-12 page-heading-strip page-heading-bar no-padding dont-display">
    <div class="col-xs-3 col-lg-1 col-md-1">
        <a>
            <span class="img-span"><img class="back-arrow" src="assets/img/svg/back-arrow.svg"></span>
            <span class="back-label">BACK</span>
        </a>
    </div>
    <div class="col-xs-9 col-lg-11 col-md-11">
        <h3 class="col-md-11 text-center page-heading"> RESUME APPLICATION </h3>
    </div>
</div>
<div class="container no-padding full-width border-head cboth main-fix-footer-pad">
    <section *ngIf="showLoader">
        <app-loader></app-loader>
    </section>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding flex-center-div mob-pad-10">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 left-sec no-padding dont-display">
        </div>
        <div
            class="col-xs-12 col-sm-12 col-md-6 col-lg-6 right-sec no-padding card-box-shadow top-bottom-spec-50 mob-top-bottom-spc-40">
            <div class="container-fluid no-padding">
                <div class="col-xs-12 col-md-12 margin-spec">
                    <div class="clearfix background-spec">
                        <form [formGroup]="ResumeApplicationForm">
                            <div class="clearfix page-heading-wrapper">
                                <h3 class="page-heading">Resume Application</h3>
                            </div>
                            <div class="clearfix">
                                <div *ngIf="ParamObj" class="label-text col-xs-12 col-md-6 top-spc-10"
                                    [ngClass]="ParamObj ? 'no-border-right' : 'divider-spec'">
                                    <label>Mobile Number</label>
                                    <div class="col-xs-12 label-val">
                                        <div class="content-margin-spec font-spec" x-ms-format-detection="none">+91
                                            {{MobileNumber}}</div>
                                    </div>
                                </div>
                                <div *ngIf="!ParamObj">
                                    <div class="form-group mobileField col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-spc"
                                        x>
                                        <div class="input-group"
                                            [ngClass]="FormValidators.FieldHasErrors(ResumeApplicationForm, 'mobile') || IsCorrectMobile ? 'text-danger' : '' ">
                                            <input id="resumeMobCode" type="text" [disabled]="true" class="mobCode"
                                                value="+91" />
                                            <input id="resumeMobile" type="tel" (paste)="IsPaste($event)"
                                                (keypress)="FormValidators.IsNumeric($event)" maxlength="10"
                                                minlength="10" class="form-control formControl" formControlName="mobile"
                                                aria-label="Mobile Number" name="mobile" autocomplete="off"
                                                (blur)="ValidateMobile()" required>
                                            <label class="formLabel"
                                                [ngClass]="(ResumeApplicationForm.controls['mobile'].value) ? 'atTop' : 'atBottom'">Mobile
                                                Number</label>
                                        </div>
                                        <div class="text-danger"
                                            *ngIf="FormValidators.FieldHasErrors(ResumeApplicationForm, 'mobile') || IsCorrectMobile">
                                            <span
                                                *ngIf="FormValidators.FieldHasSpecificError(ResumeApplicationForm, 'mobile', 'required')">
                                                Please provide your mobile number.
                                            </span>
                                            <span
                                                *ngIf="FormValidators.FieldHasSpecificError(ResumeApplicationForm, 'mobile', 'minlength')">
                                                Please provide your 10 digits mobile number.
                                            </span>
                                            <span
                                                *ngIf="!FormValidators.FieldHasErrors(ResumeApplicationForm, 'mobile') && IsCorrectMobile">
                                                {{IsCorrectMobile}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row btnOtpGroup" *ngIf="!ShowOTPField">
                                <div class="col-xs-12 text-center bottom-spc-20">
                                    <button type="button" id="btn_Send_OTP" class="btn btn-primary"
                                        (click)="SendMobileOTP()" [disabled]="ResendOtpExceedFlag || !CheckValid()"
                                        tabindex="5">Send OTP</button>
                                </div>
                            </div>
                            <div *ngIf="ShowOTPField"
                                class="form-group otpField col-lg-12 col-sm-12 col-xs-12 col-md-12 top-spc-20 pad-bottom-50 ">
                                <div class="input-group"
                                    [ngClass]="FormValidators.FieldHasErrors(ResumeApplicationForm,'otp') ? 'text-danger':'' ">
                                    <input id="resumeOTP" type="tel" maxlength="6" formControlName="otp"
                                        class="form-control text-capitalize formControl" aria-label="otp"
                                        autocomplete="off" name="otp" (paste)="IsPaste($event)" pattern="^[0-9]{6}$"
                                        (keypress)="FormValidators.IsNumeric($event)" required>
                                    <label class="formLabel"
                                        [ngClass]="(ResumeApplicationForm.controls['otp'].value) ? 'atTop' : 'atBottom'">OTP</label>
                                    <div class="" *ngIf="!showLoader">
                                        <button id="btnNavigateToView" *ngIf="ParamObj"
                                            class="input-group-addon btn btn-pos" (click)="NavigateToView()"
                                            [disabled]="!ResumeApplicationForm.valid || WrongOtpMsg || MobileOtpTrails >= 5 ">
                                            <i class="fontIcon-39"
                                                [ngClass]="ResumeApplicationForm.valid && !WrongOtpMsg && MobileOtpTrails < 5 ? 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Previous Rotate-180 top-margin-2' : 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Next'">
                                                <span class="path1"></span>
                                                <span class="path2"></span>
                                                <span class="path3"></span>
                                            </i>
                                        </button>
                                        <button id="btnResumeNavigateToView" *ngIf="!ParamObj"
                                            class="input-group-addon btn btn-pos" (click)="NavigateToView()"
                                            [disabled]="!ResumeApplicationForm.valid || WrongOtpMsg || MobileOtpTrails >= 5">
                                            <i class="fontIcon-39"
                                                [ngClass]="ResumeApplicationForm.valid && !WrongOtpMsg && MobileOtpTrails < 5 ? 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Previous Rotate-180 top-margin-2' : 'icon-gpgpfonts-Bajaj_Icon_GPGP_01_Next'">
                                                <span class="path1"></span>
                                                <span class="path2"></span>
                                            </i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row"
                                    *ngIf="ServiceOTPError || WrongOtpMsg || (MobileOtpTrails >= 5) || FormValidators.FieldHasErrors(ResumeApplicationForm,'otp')">
                                    <div class="col-xs-12">
                                        <span class="text-danger fontStyle"
                                            *ngIf="ServiceOTPError && MobileOtpTrails < 5">{{ServiceOTPError}}</span>
                                        <span class="text-danger fontStyle"
                                            *ngIf="WrongOtpMsg && MobileOtpTrails < 5">{{WrongOtpMsg}}</span>
                                        <span class="text-danger fontStyle"
                                            *ngIf="FormValidators.FieldHasErrors(ResumeApplicationForm,'otp')">
                                            Please provide OTP.
                                        </span>
                                        <span class="text-danger fontStyle"
                                            *ngIf="!FormValidators.FieldHasErrors(ResumeApplicationForm,'otp') && MobileOtpTrails >= 5">
                                            You've exhausted all 5 attempts to enter the correct OTP. Please resume your
                                            application after 10 minutes.
                                        </span>
                                    </div>
                                </div>
                                <br />
                                <div *ngIf="ParamObj" class="row"
                                    [ngClass]="WrongOtpMsg || MobileOtpTrails >= 5 || FormValidators.FieldHasErrors(ResumeApplicationForm,'otp') ? 'top-spc-20px' : ''">
                                    <div class="col-xs-12" [ngClass]="MobileOtpTrails >= 5 ? 'disabled-text' : ''">
                                        <label class="subTitle">
                                            <a id="btnResumeResendOtp" (click)="ResendOTP(ResumeApplicationForm.value)"
                                                class="text-left otp-btn-spec"
                                                [ngClass]="(OTPResend || MobileOtpTrails) >= 5 || ServiceError ?'disabledDiv':''">{{ParamObj.OTP
                                                || OTPResend ? 'Resend OTP' : 'Send OTP'}}</a>
                                        </label>
                                    </div>
                                    <br />
                                    <div class="col-xs-12 text-success top-spc-20px"
                                        *ngIf="IsOTPResend && OTPResend !== 5">OTP resend successfully! </div>
                                    <div class="col-xs-12 text-success top-spc-20px text-danger fontStyle"
                                        *ngIf="IsOTPResend && OTPResend === 5">You've exhausted all 5 attempts to enter
                                        the correct OTP. Please resume your application after 10 minutes.</div>
                                    <div class="col-xs-12 text-success top-spc-20px text-danger fontStyle"
                                        *ngIf=ServiceError>{{ServiceError}}</div>
                                </div>
                                <div *ngIf="!ParamObj" class="row"
                                    [ngClass]="WrongOtpMsg || MobileOtpTrails >= 5 || FormValidators.FieldHasErrors(ResumeApplicationForm,'otp') ? 'top-spc-20px' : ''">
                                    <div class="col-xs-12" [ngClass]="MobileOtpTrails >= 5 ? 'disabled-text' : ''">
                                        <label class="subTitle">
                                            <a id="btnResumeSendOtp" (click)="ResendOTP(ResumeApplicationForm.value)"
                                                class="text-left otp-btn-spec"
                                                [ngClass]="(OTPResend || MobileOtpTrails) >= 5 ?'disabledDiv':''">Send
                                                OTP</a>
                                        </label>
                                    </div>
                                    <br />
                                    <div class="col-xs-12 text-success top-spc-20px"
                                        *ngIf="IsOTPResend && OTPResend !== 5">OTP send successfully! </div>
                                    <div class="col-xs-12 text-success top-spc-20px text-danger fontStyle"
                                        *ngIf="IsOTPResend && OTPResend === 5">You've exhausted all 5 attempts to enter
                                        the correct OTP. Please resume your application after 10 minutes.</div>
                                    <div class="col-xs-12 text-success top-spc-20px text-danger fontStyle"
                                        *ngIf=ServiceError>{{ServiceError}}</div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>